import { render, staticRenderFns } from "./DocIncomeForecast.vue?vue&type=template&id=797f0a2a&"
import script from "./DocIncomeForecast.vue?vue&type=script&lang=js&"
export * from "./DocIncomeForecast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports